import { Route } from 'react-router-dom';
import BusinessPage from './pages/BusinessPage';

export const BusinessRoutes = [
  <Route key="business" path="/dashboard/business" element={<BusinessPage />} />
];